import { QuestionAttachmentType } from './question-attachment-type.enum';
import {
  ChatMessage,
  ChatMessageTypes,
  RedirectInfo,
} from './message-interface';
import { ComposedSurveyPlugin } from '@hyper-inferno/survey-elements-core';
import { ComposedPage } from '../page/composed-page.builder';
// import { coerecedPayloadBuilder } from './schema-validators';

export class ChatMessageBuilder {
  private chatMessage: ChatMessage;

  constructor() {
    this.chatMessage = { messageType: ChatMessageTypes.UNKNOWN };
  }

  setMessageType(messageType: ChatMessage['messageType']): this {
    this.chatMessage.messageType = messageType;
    return this;
  }

  setMessage(message: string): this {
    this.chatMessage.message = message;
    return this;
  }
  setMessageTime(time?: string): this {
    this.chatMessage.messageTime = time;
    return this;
  }
  setMessageMedia(
    mediaUrl: string,
    atachmentType: QuestionAttachmentType,
  ): this {
    this.chatMessage.messageMediaUrl = mediaUrl;
    this.chatMessage.mediaType = atachmentType;
    return this;
  }

  setRecipient(recipient: string): this {
    this.chatMessage.recipient = recipient;
    return this;
  }

  setSender(sender: string): this {
    this.chatMessage.sender = sender;
    return this;
  }

  // setQuestion(question: ChatMessage['question']): this {
  //   this.setMessage(question?.questionText ?? '');
  //   this.chatMessage.question = question;
  //   this.chatMessage.messageType = ChatMessageTypes.Question;
  //   return this;
  // }

  setPage(page: ComposedPage): this {
    this.setMessage(page.name);
    this.chatMessage.page = page;
    this.chatMessage.messageType = ChatMessageTypes.Page;
    return this;
  }

  setEndSurvey(message = 'End of survey'): this {
    this.chatMessage.message = message;
    this.chatMessage.messageType = ChatMessageTypes.EndSurvey;
    return this;
  }

  setEndSurveyWithRedirect(
    redirectInfo: RedirectInfo,
    message = 'End of survey',
  ): this {
    this.chatMessage.message = message;
    this.chatMessage.redirectInfo = redirectInfo;
    this.chatMessage.messageType = ChatMessageTypes.BOT_END_REDIRECT;
    return this;
  }

  setSurveyError(message = 'An Error has occured'): this {
    this.chatMessage.message = message;
    this.chatMessage.messageType = ChatMessageTypes.BOT_ERROR;
    return this;
  }

  setAutoAdvance(isAutoAdvance: boolean): this {
    this.chatMessage.autoAdvance = isAutoAdvance;
    return this;
  }

  // setAnswer(answerObject: ResponseRecord, question: ComposedQuestion): this {
  //   this.setMessageType(ChatMessageTypes.Answer);
  //   this.chatMessage.interactiveMessage = {
  //     type: InteractionTypes.SUBMIT,
  //     submitAnswerPayload: {
  //       answerObject: coerecedPayloadBuilder(answerObject, question),
  //     },
  //   };
  //   this.chatMessage.message = 'Answer Submitted';
  //   return this;
  // }

  // setElementAnswer(answerObject: ResponseRecord, question: Element): this {
  //   this.setMessageType(ChatMessageTypes.Answer);
  //   this.chatMessage.interactiveMessage = {
  //     type: InteractionTypes.SUBMIT,
  //     submitAnswerPayload: {
  //       answerObject: answerObject,
  //     },
  //   };
  //   this.chatMessage.message = 'Answer Submitted';
  //   return this;
  // }

  setPageDuration(pageName: string, diffSeconds: number) {
    if (
      this.chatMessage.interactiveMessage?.submitAnswerPayload?.answerObject
    ) {
      this.chatMessage.interactiveMessage.submitAnswerPayload.answerObject[
        pageName + '_pageTime'
      ] = diffSeconds;
    }

    return this;
  }

  setGlobalPlugins(plugins: ComposedSurveyPlugin[]) {
    this.chatMessage.global = {
      plugins,
    };

    return this;
  }

  build(): ChatMessage {
    return this.chatMessage;
  }
}
